// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qm8wi","title":"styles_title__3UeD5"};